<template>
  <div class="big-slider">
    <div class="swiper-container" ref="bigSwiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          :class="{ reverse, outline: hasoutline }"
          v-for="(item, index) in data"
          :key="index"
        >
          <div class="image-block" data-aos="fade-up" data-aos-duration="400">
            <responsive-image
              class="image"
              :src="item.image_data"
            ></responsive-image>
            <stamp v-if="stamp.stamp_show" :stamp="stamp"></stamp>
          </div>
          <div class="text-block">
            <div class="text-wrapper">
              <h2 class="section-title">{{ item.title }}</h2>
              <div class="section-description" v-html="item.text"></div>
              <a class="btn" v-if="item.button_link" :href="item.button_link">{{
                item.button_label
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-button-prev" ref="prev"></div>
    <div class="swiper-button-next" ref="next"></div>
  </div>
</template>

<script>
import Swiper from "swiper/dist/js/swiper.js";
import responsiveImage from "./responsive-image.vue";
import stamp from "./stamp.vue";

export default {
  props: {
    items: { type: Array, required: true },
    reverse: { type: Boolean, default: false },
    stamp: { type: Object, required: true },
    hasoutline: { type: Boolean, default: false },
  },
  computed: {
    data: (t) => t.items.map((x) => JSON.parse(x)),
  },
  components: {
    responsiveImage,
    stamp,
  },
  mounted() {
    // init swiper
    const bigSwiper = new Swiper(this.$refs.bigSwiper, {
      slidesPerView: 1,
      watchOverflow: true,
      speed: 1000,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 4000,
      },
      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      },
    });
  },
};
</script>

<style lang="scss" scoped>
.big-slider {
  background-color: $grey;
  margin-bottom: 64px;
  position: relative;

  .swiper-container {
    width: 100%;
    height: 100%;
    overflow: visible;

    .swiper-slide {
      position: relative;
      display: flex;
      justify-content: space-between;

      &.outline {
        ::v-deep .image-block {
          outline: 1px white solid;
          outline-offset: -35px;

          img {
            z-index: -1;
          }

          @include res(tab-p) {
            outline-offset: -18px;
          }
        }
      }

      @include res(tab-l) {
        flex-direction: column;
        align-items: center;
      }

      &.reverse {
        flex-direction: row-reverse;

        @include res(tab-l) {
          flex-direction: column;
          align-items: center;
        }

        .image-block {
          margin-right: 55px;
          margin-left: 0;

          @include res(tab-l) {
            margin: auto;
          }
        }
      }

      .image-block {
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        width: 52%;
        bottom: 55px;
        padding-top: 52%;
        margin-left: 55px;

        ::v-deep.image {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        @include res(tab-l) {
          width: 65%;
          padding-top: 65%;
          margin: auto;
        }

        @include res(tab-p) {
          width: 80%;
          padding-top: 80%;
        }

        &.reverse {
          right: 55px;

          @include res(tab-l) {
            right: 0;
          }
        }

        &.basic {
          left: 55px;

          @include res(tab-l) {
            left: 0;
          }
        }
      }

      .text-block {
        max-width: 45%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 20px;

        @include res(tab-p) {
          max-width: 80%;
        }

        .text-wrapper {
          max-width: 350px;
          text-align: center;
          margin: 0 50px;
          font-weight: 400;

          @include res(tab-l) {
            max-width: 100%;
            margin: 0 0 35px;
          }

          .section-description {
            font-size: 14px;
            line-height: 22px;
            margin: 15px 15px;

            @include res(tab-p) {
              margin: 15px 0;
            }

            p {
              margin-top: 15px !important;
            }
          }

          h2 {
            text-transform: uppercase;
            margin: 0;
          }

          a {
            color: $dark-grey;
          }

          a.btn {
            @include button(#5C5C5C, 10px, 15px);
            border: 1px solid $dark-grey;
            display: inline-block;
            text-transform: uppercase;

            &:hover {
              color: $white;
            }

            &::before {
              @include button-hover($bg: #5C5C5C);
              color: $white;
            }

            @include res(tab-p) {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 30px;
    height: 20px;
    background-size: contain;
    outline: none;
    top: 98%;
  }
  .swiper-button {
    &-prev {
      right: 50px;
      left: auto;
      transform: rotate(180deg);
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='25px' height='45px' viewBox='0 0 25 45' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com --%3E%3Ctitle%3EUI/Next%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Module/Funiture' transform='translate(-1372.000000, -371.000000)' stroke='%23969BA5'%3E%3Cg id='UI/Next' transform='translate(1373.000000, 372.000000)'%3E%3Cg id='Icons/dropdown_arrow' transform='translate(11.000000, 21.500000) rotate(-90.000000) translate(-11.000000, -21.500000) translate(-10.000000, 11.000000)'%3E%3Cpolyline id='Path-2' stroke-width='3' points='0 0.0245707891 20.9877074 21 42 0'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      @include res(mobile) {
        display: none;
      }
    }
    &-next {
      right: 25px;
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='25px' height='45px' viewBox='0 0 25 45' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com --%3E%3Ctitle%3EUI/Next%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Module/Funiture' transform='translate(-1372.000000, -371.000000)' stroke='%23969BA5'%3E%3Cg id='UI/Next' transform='translate(1373.000000, 372.000000)'%3E%3Cg id='Icons/dropdown_arrow' transform='translate(11.000000, 21.500000) rotate(-90.000000) translate(-11.000000, -21.500000) translate(-10.000000, 11.000000)'%3E%3Cpolyline id='Path-2' stroke-width='3' points='0 0.0245707891 20.9877074 21 42 0'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      @include res(mobile) {
        display: none;
      }
    }
  }
}
</style>
